import helpers from "../helpers";

const canvas = document.getElementById('Matrix');
const context = canvas.getContext('2d');
const n = ['0', ' ', '1'];
const fps = 65;

let isInited = false;
let isPaused = true;
let timer = null;
let o = [];
let timeNow = 0;
let timeElapsed = 0;
let fontSize = null;
let spacing = null;

const vmin = (size) => size / 375 * innerWidth;
const vw = (size) => size / 1536 * innerWidth;
const px = (size) => 2560 / 1536 * size;

const draw = () => {
	context.fillStyle = 'rgba(1, 28, 64, 0.2)';
	context.fillRect(0, 0, canvas.width, canvas.height);
	context.fillStyle = 'rgba(158, 208, 248, 0.2)';

	for (let i = 0; i < o.length; i++) {
		context.fillText(n[Math.floor(Math.random() * n.length)], spacing * i, spacing * o[i]);

		spacing * o[i] > canvas.height && Math.random() > 0.975 && (o[i] = 0); // eslint-disable-line no-unused-expressions

		o[i]++;
	}
};

const animate = () => {
	if (isPaused || !isInited) {
		return;
	}

	timeNow = Date.now();

	if (timeNow > timeElapsed) {
		draw();

		timeElapsed = timeNow + fps;
	}

	timer = requestAnimationFrame(animate);
};

const pause = () => {
	if (!isPaused && isInited) {
		cancelAnimationFrame(timer);

		isPaused = true;
		timer = null;
	}
};

const play = () => {
	if (isPaused && isInited) {
		isPaused = false;

		animate();
	}
};

const setParams = () => {
	fontSize = vw(13);
	spacing = vw(13);

	if (innerWidth < 1024) {
		fontSize = vmin(18);
		spacing = vmin(18);
	} else if (innerWidth > 1536 && innerWidth < 1680) {
		fontSize = 13;
		spacing = 13;
	} else if (innerWidth >= 2560) {
		fontSize = px(13);
		spacing = px(13);
	}

	o = [];

	canvas.width = innerWidth;
	canvas.height = innerHeight;

	context.font = `${fontSize}px arial`;

	for (let r = canvas.width / spacing, c = 0; c < r; c++) {
		o[c] = 1;
	}
};

const resize = setParams;

const init = () => {
	if(helpers.isMobile()) {
		return;
	}

	isInited = true;

	setParams();
	play();
};

export default {
	init,
	resize,
	play,
	pause,
};
